import { NavLink } from "react-router-dom";

const NavItem = ({ to, label }) => {
  return (
    <li>
      <NavLink
        to={to}
        className={({ isActive }) =>
          `relative transition ${
            isActive
              ? "text-blue-700 font-semibold after:absolute after:w-full after:h-[2px] after:bg-blue-700 after:left-0 after:-bottom-1"
              : "text-gray-800 hover:text-blue-600"
          }`
        }
      >
        {label}
      </NavLink>
    </li>
  );
};

export default NavItem;